import StoredLayout from '../../layouts/StoredLayout'
import GoogleMaps from './GoogleMaps'
export default StoredLayout(GoogleMaps)



// WEBPACK FOOTER //
// ./src/maps/google-maps/index.js